var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTheme, useMediaQuery } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
export var CopyWithTooltip = memo(function CopyWithTooltip(_a) {
    var text = _a.text, _b = _a.label, label = _b === void 0 ? "" : _b, _c = _a.sx, sx = _c === void 0 ? {} : _c, _d = _a.showIcon, showIcon = _d === void 0 ? true : _d, _e = _a.showText, showText = _e === void 0 ? true : _e;
    var _f = useState(false), copied = _f[0], setCopied = _f[1];
    var _g = useState(false), openSnackbar = _g[0], setOpenSnackbar = _g[1];
    var t = useTranslation().t;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var copyToClipboard = function () {
        navigator.clipboard.writeText(text);
        setCopied(true);
        if (isMobile)
            setOpenSnackbar(true);
        setTimeout(function () { return setCopied(false); }, 2000);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Tooltip, { title: isMobile ? "" : copied ? t("copyWithTooltip.copied") : t("copyWithTooltip.copy"), arrow: true, children: _jsxs(Typography, { onClick: copyToClipboard, sx: __assign({ color: "#fff", display: "inline-flex", alignItems: "center", gap: isMobile ? "4px" : "6px", cursor: "pointer", fontSize: isMobile ? "12px" : "14px", userSelect: "none", opacity: 0.9, transition: "opacity 0.2s ease", wordBreak: "break-word", "&:hover": {
                            opacity: 1,
                            textDecoration: "underline",
                        } }, sx), children: [label && _jsxs("span", { children: [label, " "] }), showText && _jsx("span", { style: { fontWeight: 600 }, children: text }), showIcon &&
                            (copied ? (_jsx(CheckIcon, { sx: {
                                    fontSize: isMobile ? "14px" : "16px",
                                    color: "lightgreen",
                                } })) : (_jsx(ContentCopyIcon, { sx: { fontSize: isMobile ? "14px" : "16px", opacity: 0.7 } })))] }) }), _jsx(Snackbar, { open: openSnackbar, autoHideDuration: 2000, onClose: function () { return setOpenSnackbar(false); }, message: t("copyWithTooltip.copied"), anchorOrigin: { vertical: "top", horizontal: "center" } })] }));
});
